import React from "react";

import InternalServerError from "components/ErrorHandlers/InternalServerError/InternalServerError";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App Crash:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <InternalServerError />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;